<template>
<div class="container">
  <el-table
      :data="tableData"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
      :cell-style="centerStyle"
  >
    <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
    <el-table-column prop="store_id" label="所在门店"  align="center">
      <template #default="scope">
        {{ storeMap.get(scope.row.store_id) }}
      </template>
    </el-table-column>
    <el-table-column label="企业微信" align="center"  header-align="center" prop="qrcode"  show-overflow-tooltip>
      <template #header>
        <span>企业微信</span>
        <el-tooltip
            class="box-item"
            effect="dark"
            content="企业微信：是门店店长的企业微信二维码链接，用于打印小票"
            placement="top"
        >
          <el-button icon="el-icon-warning" type="text" style="color: #777"></el-button>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="name" label="姓名" align="center" width="150"></el-table-column>
    <el-table-column prop="phone" label="电话号码" width="130" align="center"></el-table-column>
    <el-table-column prop="c_at" label="加入时间" width="170" align="center"  :formatter="dateFormat"></el-table-column>
    <el-table-column label="操作" align="center"  header-align="center" width="250">
      <template #default="scope" >
        <el-button
            type="text"
            icon="el-icon-edit"
            @click="setPassword(scope.$index, scope.row)"
        >
          修改密码
        </el-button>
        <el-button
            type="text"
            icon="el-icon-edit"
            @click="setCouponRole(scope.$index, scope.row)"
        >
          优惠券权限
        </el-button>
      </template>
    </el-table-column>
  </el-table>
  <div class="pagination">
    <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="query.page"
        :page-size="query.page_size"
        :total="pageTotal"
        @current-change="handlePageChange"
    ></el-pagination>
  </div>
  <el-dialog title="修改密码" v-model="passwordVisible" width="20%">
    <el-form :model="form" :rules="rules">
      <el-form-item label="密码" prop="password" re>
        <el-input v-model="form.password" class="w200" type="password"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
                <span class="dialog-footer">
                    <el-button @click="passwordVisible = false">取 消</el-button>
                    <el-button type="primary" @click="saveEdit()">确 定</el-button>
                </span>
    </template>
  </el-dialog>
  <el-dialog title="优惠券权限" v-model="roleVisible" width="30%">
    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
    <div style="margin: 15px 0;"></div>
    <el-checkbox-group v-model="checkedRoles" @change="handleCheckedRolesChange">
      <el-checkbox v-for="role in roleOptions" :label="role" :key="role">{{role}}</el-checkbox>
    </el-checkbox-group>
    <template #footer>
                <span class="dialog-footer">
                    <el-button @click="roleVisible = false">取 消</el-button>
                    <el-button type="primary" @click="saveRole()">确 定</el-button>
                </span>
    </template>
  </el-dialog>
</div>

</template>

<script>
import {getManagerOption, getStoreOption} from "@/api/store";
import moment from "moment/moment";
import {ElTableColumn} from "element-plus";
import {SetManagerPassword} from "@/api/manager";
import {getCouponRole,saveCouponRole} from "@/api/coupon";

export default {
  name: "ManagerTable",
  components: {ElTableColumn},
  data(){
    return{
      tableData:[],
      storeOptions:[],
      storeMap:new Map(),
      query:{
        page:1,
        page_size:10
      },
      pageTotal:0,
      passwordVisible:false,
      form:{
        id:null,
        password:''
      },
      rules:{
        password:[
      { required: true, message: '请输入密码', trigger: 'blur' }
      ]},
      roleVisible:false,
      roleOptions:['编辑券','增加券','删除券','赠送券'],
      checkedRoles:[],
      checkAll:false,
      isIndeterminate: true,
      roleForm:{
        id:null,
        coupon_role:''
      }
    }
  },
  created() {
    this.init()
  },
  methods:{
    init() {
      this.getData()
      this.getStoreOption()
    },
    centerStyle(){
      return 'text-align:center'
    },
    getData(){
      getManagerOption(this.query).then(res=>{
        this.tableData = res.data
        if (this.query.page === 1) {
          this.pageTotal = res.count
        }
      })
    },
    dateFormat: function (row, column) {
      const date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD")
    },
    //获取门店信息
    getStoreOption() {
      getStoreOption(this.query).then(res => {
        let that = this
        res.forEach(function(item) {
          that.storeMap.set(Number(item.value),item.label)
        })
        this.storeOptions = res
      })
    },
    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },
    // eslint-disable-next-line no-unused-vars
    setPassword(index,row){
      this.passwordVisible = true
      this.form.password = ''
      this.form.id = row.id
    },
    saveEdit(){
      SetManagerPassword(this.form.id,{password: this.form.password}).then(res=>{
        if(res===true){
          this.$message.success('保存成功')
          this.passwordVisible = false
          this.getData()
        }
      })
    },
    // eslint-disable-next-line no-unused-vars
    setCouponRole(index,row){
      this.roleForm.id = row.id
      getCouponRole(row.id).then(res=>{
        this.checkedRoles = []
        let checkedValue = res.coupon_role.split(';')
        for (let i=0;i<checkedValue.length;i++){
          this.checkedRoles.push(this.roleOptions[checkedValue[i]-1])
        }
        this.roleVisible = true
      })
    },
    handleCheckAllChange(val) {
      this.checkedRoles = val ? this.roleOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedRolesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.roleOptions.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.roleOptions.length;
    },
    saveRole(){
      let checkedArr = []
      this.checkedRoles.forEach(item=>{
        for (let i=0;i<this.roleOptions.length;i++){
          if(this.roleOptions[i] == item){
            checkedArr.push(i+1)
          }
        }
        })
      this.roleForm.coupon_role = checkedArr.join(';')
      saveCouponRole(this.roleForm).then(res=>{
        if(res){
          this.roleVisible = false
        }
      })
    }
  }
}
</script>

<style scoped>
.w200{
  width: 200px;
}
</style>